import { Prismic, PrismicText } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import { slugify } from '@landsbankinn/utils';
import React from 'react';
import { ContentNav } from '../components/content-nav/ContentNav';

interface IProps {
  heading: Prismic.RichText;
  fields: [IField];
}
interface IField {
  subheading: Prismic.RichText;
  copy: Prismic.RichText;
}

export const ContentNavContainer = ({ heading, fields }: IProps) => {
  const chapters = fields.map((item) => {
    const title = Prismic.text(item.subheading);
    const id = slugify(title ?? undefined);
    const content = <PrismicText value={item.copy} />;
    return { id, title, content };
  });

  return (
    <Segment>
      <ContentNav heading={Prismic.text(heading)} chapters={chapters} />
    </Segment>
  );
};
